<template>
  <div v-if="show" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
      <!-- 头部 -->
      <div class="px-6 py-4 border-b border-gray-200">
        <h3 class="text-lg font-semibold text-gray-900">激活码验证</h3>
        <p class="text-sm text-gray-600 mt-1">请输入激活码以开始测评</p>
      </div>

      <!-- 内容 -->
      <div class="px-6 py-4">
        <div class="mb-4">
          <label for="activationCode" class="block text-sm font-medium text-gray-700 mb-2">
            激活码
          </label>
          <input
            id="activationCode"
            v-model="activationCode"
            type="text"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-psychology-primary focus:border-transparent"
            placeholder="请输入激活码"
            @keyup.enter="handleVerify"
            :disabled="isVerifying"
          />
        </div>

        <!-- 错误提示 -->
        <div v-if="errorMessage" class="mb-4 p-3 bg-red-50 border border-red-200 rounded-md">
          <p class="text-sm text-red-600">{{ errorMessage }}</p>
        </div>
      </div>

      <!-- 底部按钮 -->
      <div class="px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
        <button
          @click="handleCancel"
          class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
          :disabled="isVerifying"
        >
          取消
        </button>
        <button
          @click="handleVerify"
          :disabled="!activationCode.trim() || isVerifying"
          class="px-4 py-2 text-sm font-medium text-white bg-psychology-primary hover:bg-psychology-primary-dark rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span v-if="isVerifying">验证中...</span>
          <span v-else>验证</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { saveActivationCode as saveActivationCodeUtil } from '@/utils/activationUtils'

export default {
  name: 'ActivationCodeDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    targetRoute: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      activationCode: '',
      errorMessage: '',
      isVerifying: false,
      // 写死的激活码
      validCode: 'Y!lxKi8QgkFVHCjB',
      validCode1: 'c1903'
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.resetForm()
      }
    }
  },
  methods: {
    resetForm() {
      this.activationCode = ''
      this.errorMessage = ''
      this.isVerifying = false
    },
    
    handleVerify() {
      if (!this.activationCode.trim()) {
        this.errorMessage = '请输入激活码'
        return
      }

      this.isVerifying = true
      this.errorMessage = ''

      // 模拟验证延迟
      setTimeout(() => {
        if (this.activationCode.trim() === this.validCode || this.activationCode.trim() === this.validCode1) {
          // 验证成功，保存到缓存
          this.saveActivationCode()
          // 跳转到目标页面
          this.$router.push(this.targetRoute)
          // 关闭对话框
          this.$emit('close')
        } else {
          this.errorMessage = '激活码错误，请重新输入'
        }
        this.isVerifying = false
      }, 500)
    },

    handleCancel() {
      this.$emit('close')
    },

    saveActivationCode() {
      // 使用工具函数保存激活码，类型为 'verified'
      saveActivationCodeUtil(this.validCode, 'verified')
    }
  }
}
</script>
